'use strict';

/**
 * Enum definition file for promotion types.
 *
 * @module data/enums/promotion-types
 */
module.exports = {
    standard: 'STANDARD',
    split: 'SPLIT',
    attributeScoped: 'ATTRIBUTE_SCOPED',
};
